import { Component, Input, OnInit } from '@angular/core';
import { MODE } from '../../shared/constant';

// Radio Component
@Component({
  selector: 'radio-component',
  styleUrls: ['./../question.scss'],
  template: `
    <div [class.has-error]="control.touched &&!control.valid && mode != 'readOnly'"
         [ngClass]="{'col-md-4 inline-padding': questiondata.params.inline == 3,'col-md-3 inline-padding': questiondata.params.inline == 4}"
         [ngClass]="{'col-md-3 inline-padding': questiondata.params.inline == 4}"
         [attr.id]="sectionId+'_'+questiondata.order+'_div'">
         <label-text [questiondata]="questiondata" [helptext]="questiondata.helpText"
                  [attrFor]="sectionId+'_'+questiondata.order"></label-text>
      <div class="radio radio-space" *ngFor="let option of questiondata?.allowedOptions; let i=index">
        <label class="radio-chkbx-label">
          <input type="radio" [checked]="option.value == response"
                 (change)="OnChange($event, option)"
                 [attr.name]="sectionId+'_'+questiondata.order+'_'+i"
                 [attr.id]="sectionId+'_'+questiondata.order+'_'+i"
                 [attr.value]="option.value" [disabled]="control.disabled"
                 [style.width]="(!questiondata.params.inline)? questiondata.params.width + '%' : '' ">{{option.display}}
        </label>
      </div>
      <errorMessages *ngIf="mode != 'readOnly'" [control]='control' [params]='questiondata.params'
                     [isSubmitClicked]="isSubmitClicked"></errorMessages>
      <br/>
    </div><br/>
  `,
})

export class RadioComponent implements OnInit {
  @Input() questiondata: any;
  @Input() control: any;
  @Input() sectionId: any;
  @Input() isSubmitClicked;
  @Input() controlObject: any;
  @Input() mode: string;
  private response = '';

  constructor() {
  }

  ngOnInit() {
    this.init();
  }

  ngOnChanges(changes: any) {
    if (changes.mode) {
      this.init();
    }
  }

  init() {
    (this.mode === MODE.READONLY) ? this.control.disable(true) : this.control.enable(true);

    if (this.questiondata.iterations) {
      this.response = this.response || this.questiondata.iterations[0].responseText;
    }

    this.control.setValue(this.response);
  }

  OnChange($event, option) {
    this.response = $event.target.value;
    this.controlObject.value.iterations[0].responseMetadata['chosenResponses'][0] = option;
    this.control.setValue(this.response);
    this.control.markAsTouched(true);
  }
}



// WEBPACK FOOTER //
// /home/runner/work/slipresistant/slipresistant/client/src/app/form/controls/radio.component.ts